<template>
  <fragment>
    <div :class="$style['display']" class="default-display">
      {{ text }}
    </div>
    <span :class="$style['answer']">{{ answer }}</span>
  </fragment>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    render: {
      type: Function,
      default: value => value
    },
    name: {
      type: String,
      default: ""
    }
  },
  computed: {
    arrayValues() {
      return Array.isArray(this.value) ? this.value : [this.value];
    },
    text() {
      return this.arrayValues.map(value => this.render(value)).join(", ");
    },
    entity() {
      return this.$store.getters['templates/entity/entity'];
    },
    answerItems() {
     return this.$store.getters['templates/entity/answerItems'];
    },
    answer() {
      if (!this.text) {
        return '';
      }
      const itemNum = this.entity[this.name.replace('review_item_name_', 'review_item_')];
      return this.answerItems[itemNum] ? this.answerItems[itemNum] : '自由回答';
    }
  }
};
</script>

<style module lang="scss">
.display {
  font-size: 14px;
  font-weight: 600;
  max-width: 600px;
  white-space: pre-wrap;
}
</style>

<style scoped lang="scss">
.default-display {
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 420px;
}
</style>
